import React, { useState } from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpPlatformInvoiceLineItem from '../../../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceLineItem';
import TpPlatformInvoiceService from '../../../Services/TpPlatformInvoiceService';
import TpPlatformInvoiceItemSearchParams from './TpPlatformInvoiceItemSearchParams';

// Embedded grid for the item tabs of the platform-invoice detail popup. Always scoped
// to one invoice — and, on the typed tabs (Assignment/Additional/Development), to one
// cost type; both are re-stamped on every search so the user cannot search their way
// out of the tab. lineItemType picks the column set (the typed tabs pass a thin
// TpPlatformInvoiceLineItem subclass).
const TpPlatformInvoiceItemsTab = ({
  tpPlatformInvoiceId = '',
  costType = '',
  lineItemType = TpPlatformInvoiceLineItem,
}) => {
  const [searchItem, setSearchItem] = useState<any>(() => {
    const params = new (TpPlatformInvoiceItemSearchParams as any)();
    params.TpPlatformInvoiceId = tpPlatformInvoiceId;
    params.CostType = costType;
    return params;
  });

  const startSearch = (newSearchItem: any) =>
    setSearchItem({ ...newSearchItem, TpPlatformInvoiceId: tpPlatformInvoiceId, CostType: costType });

  return (
    <TabOfDataTable
      type={lineItemType}
      serviceFunction={TpPlatformInvoiceService.GetItemsBySearching}
      convertDBItemsFunction={TpPlatformInvoiceService.ConvertDBLineItems}
      searchItem={searchItem}
      searchParamsType={TpPlatformInvoiceItemSearchParams}
      showSearchStrip={true}
      clickOnStartSearch={startSearch}
      popupEnabled={false}
      singleSearchLine={true}
      singleSearchLinePlaceholder={
        costType
          ? 'Search in billing code, company, client ID...'
          : 'Search in billing code, cost type, company, client ID...'
      }
      errorCode='TPPIT01'
      useClickOnClearAll={true}
    />
  );
};

export default TpPlatformInvoiceItemsTab;
